<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div
  class="reservation-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="reservation-modal-title"
  (click)="$event.stopPropagation()">
  <button
    class="reservation-modal-close"
    type="button"
    aria-label="Cerrar modal"
    (click)="onClose()">
    <svg
      class="reservation-modal-close-icon"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.146447 0.146447C0.341709 -0.0488155 0.658291 -0.0488155 0.853553 0.146447L7.5 6.79289L14.1464 0.146447C14.3417 -0.0488155 14.6583 -0.0488155 14.8536 0.146447C15.0488 0.341709 15.0488 0.658291 14.8536 0.853553L8.20711 7.5L14.8536 14.1464C15.0488 14.3417 15.0488 14.6583 14.8536 14.8536C14.6583 15.0488 14.3417 15.0488 14.1464 14.8536L7.5 8.20711L0.853553 14.8536C0.658291 15.0488 0.341709 15.0488 0.146447 14.8536C-0.0488155 14.6583 -0.0488155 14.3417 0.146447 14.1464L6.79289 7.5L0.146447 0.853553C-0.0488155 0.658291 -0.0488155 0.341709 0.146447 0.146447Z"
        fill="black" />
    </svg>
  </button>

  <div class="reservation-modal-layout">
      <div class="reservation-modal-media">
        @if (event?.media?.length) {
          <img
            [src]="event?.media?.[0]?.url"
            alt="{{ event?.name || 'Event image' }}"
            loading="lazy">
        }
      </div>

    <div class="reservation-modal-content">
      <div class="reservation-modal-event">
        <h3 id="reservation-modal-title">
          {{ event?.name }}
        </h3>
        @if (event?.detailedInfo?.provider?.name) {
          <p class="reservation-modal-provider">
            {{ event?.detailedInfo?.provider?.name }}
          </p>
        }

        @if(!this.isComingSoon(event)) {
          <div class="reservation-modal-info-group">
            @if (event?.detailedInfo?.startDateTime) {
              <div class="reservation-modal-info-item reservation-modal-date-time">
                <div>
                  <div>{{ event?.detailedInfo?.startDateTime | safeDate:'EEEE, d MMMM':undefined:languageTag }}</div>
                  <div>{{ event?.detailedInfo?.startDateTime | safeDate:'HH:mm':undefined:languageTag }}</div>
                </div>
              </div>
            }

            @if (event?.detailedInfo?.provider?.address) {
              <div class="reservation-modal-info-item reservation-modal-place">
                {{ event?.detailedInfo?.provider?.address?.street }},
                {{ event?.detailedInfo?.provider?.address?.postalCode }}
                {{ event?.detailedInfo?.provider?.address?.city }},
                {{ event?.detailedInfo?.provider?.address?.country }}
              </div>
            }

            <div class="reservation-modal-info-item reservation-modal-duration">
              <div class="reservation-modal-info-details">
                @if (event?.detailedInfo?.durationPeriod) {
                  <div>{{ piece?.settings?.general?.durationText }}: {{ event?.detailedInfo?.durationPeriod | duration: piece?.settings?.general:lang }}</div>
                }
                @if (event?.detailedInfo?.language) {
                  <div>{{ piece?.settings?.general?.languageText }}: {{ eventLanguageDisplayName }}</div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <form
        class="reservation-modal-form"
        [formGroup]="reservationForm"
        (ngSubmit)="onSubmit()"
        novalidate>
        <div class="reservation-modal-scrollable">
        <div class="reservation-modal-fields">
          <label>
            <div class="reservation-modal-field-header">
              <span>{{ piece?.settings?.general?.nameText }}</span>
            </div>
            <div class="reservation-modal-input-with-icon">
              <input
                type="text"
                formControlName="name"
                autocomplete="given-name">
              <span
                class="reservation-modal-edit-icon"
                aria-hidden="true"></span>
            </div>
          </label>

          <label>
            <div class="reservation-modal-field-header">
              <span>{{ piece?.settings?.general?.surnameText }}</span>
            </div>
            <div class="reservation-modal-input-with-icon">
              <input
                type="text"
                formControlName="surname"
                autocomplete="family-name">
              <span
                class="reservation-modal-edit-icon"
                aria-hidden="true"></span>
            </div>
          </label>

          <label>
            <div class="reservation-modal-field-header">
              <span>{{ piece?.settings?.general?.emailText }}</span>
            </div>
            <input
              type="email"
              [value]="mail"
              readonly>
          </label>

          <div class="reservation-modal-row">
            <label>
              <span>{{ piece?.settings?.general?.prefixText }}</span>
              <input
                type="text"
                [value]="prefix"
                readonly>
            </label>

            <label>
              <div class="reservation-modal-field-header">
                <span>{{ piece?.settings?.general?.phoneText }}</span>
              </div>
              <input
                type="text"
                [value]="phone"
                readonly>
            </label>
          </div>
        </div>

        <div class="reservation-modal-legal">
          <label class="reservation-consent">
            <input
              type="checkbox"
              [checked]="acceptedMarketingTerms"
              (change)="onRequiredConsentChange()">
            <span>
              {{ piece?.settings?.general?.receiveNewsText || 'I agree to the Terms and Conditions of Use and the Privacy Policy' }}
            </span>
          </label>

          <div
            class="wysiwyg terms-conditions">
            <render-wysiwyg
              [html]="piece?.settings?.general?.termsConditionsText"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
          </div>

          <span>
            {{ piece?.settings?.general?.imageRightsText }}
          </span>
        </div>

        </div>

        <div class="reservation-modal-actions">
          <button
            class="event-reserve-btn"
            type="submit"
            [disabled]="!acceptedLegalTerms">
            @if(this.isComingSoon(event)) {
              {{ (piece?.settings?.general?.comingSoonText || 'Coming Soon') | uppercase }}
            }
            @else if ((event?.detailedInfo?.capacity || 0) - (event?.detailedInfo?.occupancy || 0) > 0) {
              {{ piece?.settings?.general?.bookYourSpotText | uppercase}}
            } @else {
              {{ piece?.settings?.general?.joinWaitlistText | uppercase}}
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
